/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PutOrderMemo200Response
 */
export interface PutOrderMemo200Response {
    /**
     * 注文メモのID
     * @type {string}
     * @memberof PutOrderMemo200Response
     */
    uuid: string;
}

/**
 * Check if a given object implements the PutOrderMemo200Response interface.
 */
export function instanceOfPutOrderMemo200Response(value: object): value is PutOrderMemo200Response {
    if (!('uuid' in value) || value['uuid'] === undefined) return false;
    return true;
}

export function PutOrderMemo200ResponseFromJSON(json: any): PutOrderMemo200Response {
    return PutOrderMemo200ResponseFromJSONTyped(json, false);
}

export function PutOrderMemo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutOrderMemo200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
    };
}

export function PutOrderMemo200ResponseToJSON(json: any): PutOrderMemo200Response {
    return PutOrderMemo200ResponseToJSONTyped(json, false);
}

export function PutOrderMemo200ResponseToJSONTyped(value?: PutOrderMemo200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
    };
}

